import { Input } from '../input/input';
import { addStyles, DefaultTheme, rgba } from '../theme';
import { WHITE } from '../theme.palette';

export const CSS = {
	container: 'c-Modal',
	modal: 'c-Modal-Container',
	title: 'c-Modal-Title',
	titleText: 'c-Modal-Title__text',
	actions: 'c-Modal-Actions',
	content: 'c-Modal-Content',

	action: {
		ok: 'c-Modal-Actions__Ok',
		cancel: 'c-Modal-Actions__Cancel',
	},

	isOpen: 'c-Modal--open',
	closeButton: 'c-Modal-Title__close',
};

export const MDL = {
	button: 'mdl-button',
};

export const MODAL_Z_INDEX = 100;

addStyles({
	[CSS.container]: {
		position: 'absolute',
		top: 0,
		left: 0,
		bottom: 0,
		right: 0,
		width: '100%',
		height: '100%',
		'background-color': DefaultTheme.font.color.supporting,
		display: 'flex',
		'justify-content': 'center',
		'align-items': 'center',
		'z-index': MODAL_Z_INDEX - 1,
		[`& .${Input.CSS.container}`]: {
			width: '100%',
		},
	},
	[CSS.modal]: {
		'z-index': MODAL_Z_INDEX,
		'min-width': '280px',
		'max-height': '90%',
		background: DefaultTheme.background.offWhite,
		display: 'flex',
		'flex-direction': 'column',
		margin: 0,
		width: 'auto',
		height: 'auto',
		opacity: 0,
		'border-radius': '8px',
		overflow: 'hidden',
		'box-shadow': DefaultTheme.shadow.box.dp2,
		transition: 'opacity 0.25s ease',
	},
	[CSS.isOpen + ' .' + CSS.modal]: {
		opacity: 1,
	},
	[CSS.title]: {
		color: rgba(WHITE),
		padding: `${DefaultTheme.space(2)} ${DefaultTheme.space(6)}`,
		'font-size': DefaultTheme.font.size * 1.1 + 'px',
		'background-color': DefaultTheme.background.darkGrey,
		display: 'flex',
		'align-items': 'center',
		gap: DefaultTheme.space(2),
	},
	[CSS.titleText]: {
		flex: 1,
	},
	[CSS.closeButton]: {
		color: rgba(WHITE),
		'&:hover': {
			color: rgba(WHITE, 0.7),
		},
	},
	[CSS.content]: {
		color: DefaultTheme.font.color.supporting,
		padding: DefaultTheme.space(6),
		'padding-bottom': DefaultTheme.space(1),
		overflow: 'auto',
		flex: 1,
		'min-height': 0,
		display: 'flex',
		'flex-direction': 'column',
	},
	[CSS.actions]: {
		'text-align': 'right',
		padding: DefaultTheme.space(2),
		[`& .${CSS.action.ok}`]: {
			color: DefaultTheme.color.accent,
		},
		[`& .${CSS.action.ok}[disabled]`]: {
			color: DefaultTheme.font.color.disabled,
			cursor: 'not-allowed',
		},
	},
});
